export default {
  getCalendarEvent: state => state.calendarEvent,
  getCalendarEvents: state => state.calendarEvents,
  getSelectedCalendars: state => state.selectedCalendars,
}
